module.exports = __webpack_public_path__ + "images/interview-Starbucks2-2.svg";